import ContentPage from '../components/ui/ContentPage';

export default function TermsPage(): JSX.Element {
  return (
    <ContentPage
      title="Termos de uso"
      intro="Estas condicións regulan o teu uso do marketplace LeyroChain — chain.leyro.es/marketplace — e da app móbil asociada."
      category="Legal"
      updatedAt="2026-05-19"
    >
      <h2>1. Quen somos</h2>
      <p>
        LeyroChain é unha plataforma de trazabilidade dixital de gando bovino operada por{' '}
        <strong
          style={{
            background: '#FEF3C7',
            color: '#92400E',
            padding: '2px 8px',
            borderRadius: '4px',
          }}
        >
          [RAZÓN SOCIAL — SL en constitución]
        </strong>
        , con sede operativa en Galicia. Ofrecemos un rexistro inalterable de eventos por animal
        (vacinas, traslados, propietarios, peso, produción) ancorado en blockchain pública
        (Polygon), un marketplace público para compradores e ferramentas móbiles para gandeiros e
        veterinarios.
      </p>

      <h2>2. Aceptación</h2>
      <p>
        Ao crear unha conta aceptas estes termos. Se non estás conforme cunha cláusula concreta, non
        uses a plataforma. Os usuarios menores de 18 anos non poden contratar servizos de pagamento
        no marketplace.
      </p>

      <h2>3. Roles e responsabilidades</h2>
      <ul>
        <li>
          <strong>Gandeiro</strong>: responsable da veracidade dos datos rexistrados sobre os seus
          animais. Asina os eventos sanitarios coa súa identidade ECDSA P-256.
        </li>
        <li>
          <strong>Veterinario</strong>: aplica actos sanitarios; asume responsabilidade colexial
          sobre as súas sinaturas (sinatura avanzada eIDAS, non cualificada).
        </li>
        <li>
          <strong>Comprador</strong>: pode reservar ou pujar polos animais publicados; o contrato de
          compravenda formalízase dixitalmente a través da plataforma.
        </li>
        <li>
          <strong>Transportista</strong>: documenta a recollida e entrega dos animais con
          xeolocalización e scan NFC do crotal/LeyroSpot.
        </li>
      </ul>

      <h2>4. Rexistro paralelo, non substitutivo</h2>
      <p>
        LeyroChain <strong>non substitúe</strong> os rexistros oficiais SITRAN, MAPA ou REGA. Os
        actos veterinarios oficiais seguen requirindo o certificado dixital colexial. A nosa función
        é dar valor engadido: histórico verificable para subasta ou venda directa, comprobación
        rápida en campo, transparencia para o consumidor final via QR público.
      </p>

      <h2>5. Pagamentos</h2>
      <p>
        As compras procésanse a través da plataforma con escrow: o cargo retense ata que ambas
        partes confirman a entrega. A comisión actual da plataforma é dun 2,5 % ao vendedor + 2,5 %
        ao comprador (5 % combined) sobre o importe da venda, cunha comisión mínima de 10 € por
        parte (20 € total). As tarifas de subscrición SaaS para gandeiros publícanse en{' '}
        <a href="/marketplace/plans">/marketplace/plans</a>.
      </p>

      <h2>6. Cancelación de conta</h2>
      <p>
        Podes solicitar o borrado da túa conta dende <a href="/marketplace/profile">o teu perfil</a>
        . Os eventos asinados sobre animais mantéñense por integridade da cadea histórica, pero
        anonimizase a túa identidade persoal (nome, contacto, datos fiscais). Os hashes anclados en
        Polygon son inmutables por natureza.
      </p>

      <h2>7. Lei aplicable</h2>
      <p>
        Estes termos rexen pola lexislación española. Calquera disputa someterase aos xulgados
        competentes do domicilio social da empresa operadora, sen prexuízo dos dereitos do
        consumidor recoñecidos polo RD 1/2007.
      </p>
    </ContentPage>
  );
}
